var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDlpFooterFacebookIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    rx: 21,
    fill: "white",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.7188 21.25C29.7188 25.6094 26.5195 29.2305 22.3359 29.8633V23.7812H24.375L24.7617 21.25H22.3359V19.6328C22.3359 18.9297 22.6875 18.2617 23.7773 18.2617H24.8672V16.1172C24.8672 16.1172 23.8828 15.9414 22.8984 15.9414C20.9297 15.9414 19.6289 17.1719 19.6289 19.3516V21.25H17.4141V23.7812H19.6289V29.8633C15.4453 29.2305 12.2812 25.6094 12.2812 21.25C12.2812 16.4336 16.1836 12.5312 21 12.5312C25.8164 12.5312 29.7188 16.4336 29.7188 21.25Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDlpFooterFacebookIcon);
export default __webpack_public_path__ + "static/media/DlpFooterFacebookIcon.c6093d7fb8eb546e41f7b0d063b0ccd6.svg";
export { ForwardRef as ReactComponent };